// client/src/footer.jsx
import React from 'react';
import { Container, Typography, Box, Grid, IconButton, SvgIcon } from '@mui/material';
import { GitHub, X, Reddit } from '@mui/icons-material';

// Custom TikTok Icon (since MUI doesn’t have one built-in)
const TikTokIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path
      d="M35.5 13.5c-2.3-1.5-3.9-3.9-4.3-6.7h-4.4v24.8c0 2.7-2.2 4.9-4.9 4.9s-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9c.5 0 1 .1 1.5.2v-4.4c-.5-.1-1-.1-1.5-.1-5.1 0-9.3 4.2-9.3 9.3s4.2 9.3 9.3 9.3 9.3-4.2 9.3-9.3V17c1.7 1.3 3.9 2.1 6.2 2.1v-5.6z"
      fill="currentColor"
    />
  </SvgIcon>
);

const Footer = () => {
  return (
    <Box bgcolor="#0B3D5C" color="#FFFFFF" py={4}>
      <Container maxWidth="md">
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          {/* Social Icons */}
          <Grid item xs={12} textAlign="center">
            <Box display="flex" justifyContent="center" mb={2}>
              {/* GitHub */}
              <IconButton
                href="https://github.com/PythonShinobi"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#171515', // GitHub official black
                  transition: 'color 0.3s ease',
                  '&:hover': { color: '#DAA520' }, // soft cream hover
                }}
              >
                <GitHub fontSize="large" />
              </IconButton>

              {/* X (Twitter) */}
              <IconButton
                href="https://twitter.com/PythonShinobi"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#000000', // Twitter X logo (black)
                  transition: 'color 0.3s ease',
                  '&:hover': { color: '#DAA520' }, // soft cream hover
                }}
              >
                <X fontSize="large" />
              </IconButton>

              {/* Reddit */}
              <IconButton
                href="https://www.reddit.com/user/pythonshinobi/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#FF4500', // Reddit official orange
                  transition: 'color 0.3s ease',
                  '&:hover': { color: '#DAA520' }, // golden amber hover
                }}
              >
                <Reddit fontSize="large" />
              </IconButton>

              {/* TikTok */}
              <IconButton
                href="https://www.tiktok.com/@8anime.to"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#69C9D0', // TikTok teal
                  transition: 'color 0.3s ease',
                  '&:hover': { color: '#EE1D52' }, // TikTok pink hover
                }}
              >
                <TikTokIcon fontSize="large" />
              </IconButton>
            </Box>
          </Grid>          
        </Grid>
        <Box mt={4} textAlign="center">
          <Typography variant="body2" gutterBottom>
            © {new Date().getFullYear()} All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;